import template from "./card-swipe-modal.html";
import "./card-swipe-modal.less";
import { find } from "lodash";
import moment from "moment";
import { nestedEntityEffectiveRangeStatus } from "../../../utils/effectiveRanges";

export class Controller {
	constructor($scope, hotkeys, $timeout, $userProfile, entityManager) {
		this.$scope = $scope;
		this.hotkeys = hotkeys;
		this.$timeout = $timeout;
		this.userProfile = $userProfile.getUserProfile();
		this.entityManager = entityManager;
	}

	$onInit() {
		this.clearData();
		this.dealerField = { ...find(this.resolve.formConfig.Fields, (field) => field.Key.Code === "REPORT.ENTITIES.DEALERS.LICENSES.SINGLE") };
		this.dealerField.isTiered = this.dealerField.EntityQueryConfiguration
			&& this.dealerField.EntityQueryConfiguration.Friendly.Type.Code != this.dealerField.EntityQueryConfiguration.Primary.Type.Code;
		this.enableCardReader = false;

		this.dealerField.Data = this.filterEntitiesByEffective();

		this.modalInstance.closed.then(() => {
			if(this.userProfile.shortcutsEnabled) {
				this.hotkeys.unpause();
			}
		});

		this.modalInstance.opened.then(() => {
			this.hotkeys.pause();
		});
	}

	setDealerSelectionCtrl = (selectionCtrl) => {
		this.dealerSelectionCtrl = selectionCtrl;

		const unwatchDealerSelection = this.$scope.$watch(
			() => this.dealerSelectionCtrl?.getCurrentValue(true)[0]?.EntityId,
			(entityId) => this.onDealerValueChange(this.getDealerEntity(entityId))
		);

		return () => {
			unwatchDealerSelection();
			this.dealerSelectionCtrl = null;
		};
	}

	getDealerEntity(entityId) {
		return entityId ? this.entityManager.getEntity(this.dealerField.Id, entityId) : null;
	}

	onDealerValueChange = (selectedDealer) => {
		if(selectedDealer) {
			this.enableCardReader = true;
			this.selectedDealer = selectedDealer;
		}
		else {
			this.enableCardReader = false;
			this.selectedDealer = null;
		}

		this.$timeout(function() {
			const sel = window.document.getElementById("card-data-input");

			sel && sel.focus();
		});
	}

	filterEntitiesByEffective() {
		const now = moment();
		const effectiveAsOf = { fromInclusive: now, toExclusive: now, allowPartial: true };

		const candidates = this.dealerField.Data.reduce((entities, entity) => {
			const status = nestedEntityEffectiveRangeStatus(entity, effectiveAsOf);
			if(status.isValid || status.children?.hasValid) {
				entities.valid.push(entity);
			} 
			else if(status.isInGrace || status.children?.hasGrace) {
				entities.grace.push(entity);
			}

			return entities;
		}, {
			valid: [],
			grace: []
		});

		return candidates.valid.length ? candidates.valid : candidates.grace;
	}

	handleClose() {
		this.modalInstance.dismiss();
	}

	saveAndClose(report) {
		this.modalInstance.close(report);
	}

	emptySetFieldDirty = () => {}

	createTicket() {
		const reportResponse = [
			{
				fieldId: this.dealerField.Id,
				value: this.selectedDealer.Id
			},
			{
				fieldId: this.fishermanField.Id,
				value: this.reportInfo.fishermanLicense.Entity.Id,
				isDetail: true
			}
		];

		if(this.reportInfo.vessel) {
			reportResponse.push({
				fieldId: this.vesselField.Id,
				value: this.reportInfo.vessel.Id
			});
		}

		this.saveAndClose(reportResponse);
	}

	clearData() {
		this.cardData = "";
		this.reportInfo = null;
		this.enableCardReader = false;
		this.selectedDealer = null;
	}

	cardDataChange() {
		if(this.cardData) {
			this.findUnbrokenCardData();

			if(this.cardData) {
				const cardInfo = this.ExtractDataFromTrack(this.cardData);

				this.reportInfo = this.GetFormDataFromTrackData(cardInfo);

				this.cardData = "";
			}
		}
	}

	findUnbrokenCardData() {
		const beginIndex = this.cardData.lastIndexOf("%");
		const endIndex = this.cardData.indexOf("?", beginIndex);

		this.cardData = this.cardData && this.cardData.substring(beginIndex, endIndex + 1);
	}

	ExtractDataFromTrack(track) {
		let searchEndIndex = -1;
		const cardData = [];

		track = track.substring(0, track.length - 1);

		do {
			const searchStartIndex = track.indexOf("*", searchEndIndex);
			searchEndIndex = track.indexOf("*", searchStartIndex + 1);

			const thisDataString = track.substring(searchStartIndex + 1, searchEndIndex > -1 ? searchEndIndex : undefined);

			cardData.push(thisDataString);
		} while(searchEndIndex > -1);

		const licenseCardData = this.extractSubdataFromCardField(cardData[0]);

		const yearCode = cardData[1];
		const vesselCode = cardData[2].substring(1);  //ignore S at beginning of code

		return {
			...licenseCardData,
			yearCode,
			vesselCode
		};
	}

	extractSubdataFromCardField(data) {
		const cardsIssued = parseInt(data.substring(0, 2));
		const agencyCode = data.substring(2, 4);
		const licenseNumber = data.substring(4);

		return {
			cardsIssued, agencyCode, licenseNumber
		};
	}

	GetFormDataFromTrackData(trackData) {
		const formConfig = this.resolve.formConfig;

		this.vesselField = find(formConfig.Fields, (field) => field.Key.Code === "REPORT.ENTITIES.VESSEL.SINGLE");
		this.fishermanField = find(formConfig.Fields, (field) => field.Key.Code === "REPORT.ENTITIES.FISHERMEN.LICENSES.SINGLE");

		let thisVesselLicense = null;
		const thisVessel = find(this.vesselField.Data, (data) => {
			if(data.isSelf || (data.Entities && data.Entities.length === 1 && data.Entities[0].Type.Code === "SELF")) {
				return data.Code === trackData.vesselCode;
			}
			else {
				thisVesselLicense = find(data.Entities, (entity) => entity.Entity.Code === trackData.vesselCode);
				return thisVesselLicense !== null;
			}
		});

		let thisFishermanLicense = null;
		const thisFisherman = find(this.fishermanField.Data, (data) => {
			if(data.isSelf || (data.Entities && data.Entities.length === 1 && data.Entities[0].Type.Code === "SELF")) {
				return data.Code === trackData.licenseNumber;
			}
			else {
				thisFishermanLicense = find(data.Entities, (entity) => entity.Entity.Code === trackData.licenseNumber);
				return thisFishermanLicense !== null && thisFishermanLicense !== undefined;
			}
		});

		return { vessel: thisVessel, fisherman: thisFisherman, vesselLicense: thisVesselLicense, fishermanLicense: thisFishermanLicense };
	}
}

export default angular
	.module("vesl.components.card-swipe-modal", []) //"cfp.hotkeys"
	.component("cardSwipeModal", {
		controller: Controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	}).name;
